import gql from 'graphql-tag';

export const DELETE_TRAFFICKING_CUSTOM_FILTER = gql`
  mutation DELETE_TRAFFICKING_CUSTOM_FILTER($id: ID!) {
    deleteTraffickingCustomFilter(id: $id)
  }
`;
